import { Section } from "@/components/ui/Section";
import { SERVICES } from "@/data/mock";
import { Lock, Unlock } from "lucide-react";

const PHASES = [
  { n: 1, label: "Foundation", color: "text-brand-blue", desc: "Trust infrastructure. Runs before any paid media." },
  { n: 2, label: "Growth", color: "text-brand-red", desc: "Unlocked at Brand Strength Score ≥ 75. Ads on, funnels scaled." },
  { n: 3, label: "Retention", color: "text-silver-200", desc: "Lifetime value expansion, referrals, customer success." },
];

export default function Services() {
  return (
    <>
      <Section
        eyebrow="// Services"
        title="Phased. Gated. Compounding."
        subtitle="Every engagement starts in Phase 1 — we build trust first. Phase 2 unlocks only when your Brand Strength Score crosses 75. Phase 3 is retention and LTV expansion."
      >
        <div className="grid gap-8 md:grid-cols-3">
          {PHASES.map((p) => {
            const items = SERVICES.filter((s) => s.phase === p.n);
            return (
              <div key={p.n} className="panel p-6">
                <div className="flex items-center justify-between">
                  <div className="eyebrow">// Phase {p.n}</div>
                  {p.n === 2 ? (
                    <span className="chip-red"><Lock size={10} /> BSS ≥ 75</span>
                  ) : (
                    <span className="chip"><Unlock size={10} /> Always-on</span>
                  )}
                </div>
                <h3 className={`display-md mt-2 ${p.color}`}>{p.label}</h3>
                <p className="text-silver-300 text-sm mt-2">{p.desc}</p>
                <div className="hairline my-6" />
                <ul className="space-y-4">
                  {items.map((s) => (
                    <li key={s.code}>
                      <div className="flex items-baseline justify-between">
                        <div className="font-display font-semibold text-silver-50">{s.name}</div>
                        <div className="font-mono text-[10px] uppercase text-silver-300">effort {s.effort}</div>
                      </div>
                      <div className="text-silver-300 text-sm mt-1">{s.summary}</div>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </Section>
    </>
  );
}
